import { Bar } from "react-chartjs-2";
import CustomerLoader from "../../../../../components/CustomLoader";
import { Grid, GridColumn, GridColumnProps } from "@progress/kendo-react-grid";
import {
  CenteredWholeNumCell,
  HeaderCenteredCell,
} from "../../../../../components/DynamicGrid/customCells";
import { TotalRow } from "../../../../../components/DynamicGrid/customRows";
import { TableContainer } from "../../../Users/User.style";
import { ChartContainer, NoData } from "../../style";
import {
  barOptions,
  doTransformData,
  doTransformDataShift,
  handlePointClicked,
  prepareChartData,
  shift2HourSpanCols,
  transformDataForBarChart,
} from "../formUtils";
import { Child, Container, Header, LayerContent } from "../style";
import { useAnalyticsWrapper } from "../../../../../store/store";
import useAnalytics from "../../../../../hooks/useAnalytics";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import SectionModal from "./SectionModal";
import {
  handleCSVDownload,
  handlePDFDownload,
} from "../../../../../utils/helpers/pdfCsvUtils";
import { incidentLists } from "../../dummyData/colums";

const TimeOfIncident = ({
  setClickedIncident,
  isFetchingSelectedIncident,
  shareTableData,
}: any) => {
  const [multiTableData, setMultiTableData] = useState<any>([]);
  const [gridMorning, setGridMorning] = useState<any>([]);
  const [gridAfternoon, setGridAfternoon] = useState<any>([]);
  const [gridNight, setGridNight] = useState<any>([]);
  const [barData, setBarData] = useState<any>([]);
  const [shift, setShift] = useState("");
  const [showTimeModal, setShowTimeModal] = useState(false);
  const [timeDetails, setTimeDetails] = useState<any>([]);
  const [shiftBarData, setShiftBarData] = useState<any>([]);

  const { startDate, endDate, fallFacility } = useAnalyticsWrapper((state) => ({
    startDate: state.startDate,
    endDate: state.endDate,
    fallFacility: state.fallFacility,
  }));

  const { getOverviewOfShiftAndUnitFallIncidents, getShiftAndUnitDetails } =
    useAnalytics({
      facility: fallFacility?.value || "",
      startDate: moment(startDate).format("yyyy-MM-DD"),
      endDate: moment(endDate).format("yyyy-MM-DD"),
      uShift: shift,
    });

  const { data: shiftAndUnitData, isFetching: isFetchingShiftAndUnit } =
    getOverviewOfShiftAndUnitFallIncidents;

  const { data: shiftAndUnitDetailsData, isFetching: isLoadingDetails } =
    getShiftAndUnitDetails;

  const { getOverviewTimeOfIncident2HourSpans, getTimeOfIncidentDetails } =
    useAnalytics({
      facility: fallFacility?.value || "",
      startDate: moment(startDate).format("yyyy-MM-DD"),
      endDate: moment(endDate).format("yyyy-MM-DD"),
      shift: shift,
    });

  const { data: timeOfIncidentData, isFetching: isFetchingTimeOfIncident } =
    getOverviewTimeOfIncident2HourSpans;

  const { data: timeDetailsData, isFetching: isLoadingTimeDetails } =
    getTimeOfIncidentDetails;

  useEffect(() => {
    if (timeOfIncidentData !== undefined) {
      const tempData = timeOfIncidentData?.data.data;
      const transformedTableData = doTransformData(
        tempData,
        "dataInfo",
        "shift",
        "Total"
      );
      const transformedBarData = transformDataForBarChart(
        transformedTableData,
        "Time Count"
      );

      const transformedDataShift = doTransformDataShift(
        tempData,
        "dataInfo",
        "shift"
      );

      setMultiTableData(transformedDataShift);
      shareTableData(transformedDataShift);
      setBarData(transformedBarData);
    }
  }, [timeOfIncidentData]);

  useEffect(() => {
    if (shiftAndUnitData !== undefined) {
      const tempData = shiftAndUnitData?.data.data;
      const transformedData = doTransformData(
        tempData,
        "dataInfo",
        "shift",
        "Total"
      );
      const { shiftChartData, unitChartData } =
        prepareChartData(transformedData);
      setShiftBarData(shiftChartData);
    }
  }, [shiftAndUnitData]);

  useEffect(() => {
    if (timeDetailsData) {
      const tempDetails = timeDetailsData.data.data.map((item: any) => ({
        ...item,
      }));
      setTimeDetails(tempDetails);
    }
  }, [timeDetailsData]);

  useEffect(() => {
    if (shiftAndUnitDetailsData) {
      const tempDetails = shiftAndUnitDetailsData.data.data.map((item: any) => ({
        ...item,
      }));
      setTimeDetails(tempDetails);
    }
  }, [shiftAndUnitDetailsData]);

  const title = "Overview of Shift and Fall Time";

  const handleBarClicked = (chart: any) => {
    if (!chart.length) return;
    const label = handlePointClicked(chart, barData?.labels);
    setShowTimeModal(true);
    setShift(label);
  };

  const shiftBarClicked = (chart: any) => {
    if (!chart.length) return;
    const label = handlePointClicked(chart, shiftBarData?.labels);
    setShowTimeModal(true);
    setShift(label);
  };

  useEffect(() => {
    let cellCountProps = {
      cells: { data: CenteredWholeNumCell, headerCell: HeaderCenteredCell },
    };
    let cellPercentageProps = {
      cells: {
        data: CenteredWholeNumCell,
        append: "%",
        headerCell: HeaderCenteredCell,
      },
      append: "%",
    };
    const grid_morning = (
      <Fragment>
        <Grid
          data={multiTableData?.["Morning Shift"] || []}
          scrollable="none"
          rows={{ data: TotalRow }}
        >
          <GridColumn field="shift" title="Morning Shift" />
          <GridColumn
            field="count"
            title="Number"
            {...(cellCountProps as GridColumnProps)}
          />
          <GridColumn
            field="percentage"
            title="%"
            {...(cellPercentageProps as GridColumnProps)}
          />
        </Grid>
      </Fragment>
    );
    setGridMorning(grid_morning);
    const grid_afternoon = (
      <Fragment>
        <Grid
          data={multiTableData?.["Afternoon Shift"] || []}
          scrollable="none"
          rows={{ data: TotalRow }}
        >
          <GridColumn field="shift" title="Afternoon Shift" />
          <GridColumn
            field="count"
            title="Number"
            {...(cellCountProps as GridColumnProps)}
          />
          <GridColumn
            field="percentage"
            title="%"
            {...(cellPercentageProps as GridColumnProps)}
          />
        </Grid>
      </Fragment>
    );
    setGridAfternoon(grid_afternoon);
    const grid_night = (
      <Fragment>
        <Grid
          data={multiTableData?.["Night Shift"] || []}
          scrollable="none"
          rows={{ data: TotalRow }}
        >
          <GridColumn field="shift" title="Night Shift" />
          <GridColumn
            field="count"
            title="Number"
            {...(cellCountProps as GridColumnProps)}
          />
          <GridColumn
            field="percentage"
            title="%"
            {...(cellPercentageProps as GridColumnProps)}
          />
        </Grid>
      </Fragment>
    );
    setGridNight(grid_night);
  }, [multiTableData]);

  return (
    <LayerContent>
      {isFetchingTimeOfIncident ? (
        <CustomerLoader />
      ) : (
        <Fragment>
          <Header>{title}</Header>
          <Container>
            <Child flex="40%">
              <TableContainer>{gridMorning}</TableContainer>
              <TableContainer>{gridAfternoon}</TableContainer>
              <TableContainer>{gridNight}</TableContainer>
            </Child>
            <Child flex="60%">
              <ChartContainer>
                {barData?.labels?.length > 0 ? (
                  <Bar options={barOptions(handleBarClicked)} data={barData} />
                ) : (
                  <NoData>No Data</NoData>
                )}
              </ChartContainer>
              <ChartContainer
                id="shift-fall-chart"
                style={{ marginTop: "20px" }}
              >
                {shiftBarData?.labels?.length > 0 ? (
                  <Bar
                    options={barOptions(shiftBarClicked)}
                    data={shiftBarData}
                  />
                ) : (
                  <NoData>No Data</NoData>
                )}
              </ChartContainer>
            </Child>
          </Container>
        </Fragment>
      )}
      {showTimeModal ? (
        <SectionModal
          open={showTimeModal}
          facilityName={fallFacility?.label}
          startDate={startDate}
          endDate={endDate}
          closeFn={() => setShowTimeModal(false)}
          resetFn={() => {
            setShift("");
            setTimeDetails(undefined);
          }}
          isLoading={isLoadingTimeDetails || isFetchingSelectedIncident}
          tableData={timeDetails}
          title={`${title} - (${shift})`}
          getUserCallback={(item: any) => setClickedIncident(item)}
          handlePdfExport={() =>
            handlePDFDownload({
              data: timeDetails,
              columnData: incidentLists(),
              fileName: fallFacility?.label,
              startDate,
              endDate,
              subTitle: `${title} - ${shift}`,
            })
          }
          handleCsvExport={() =>
            handleCSVDownload(
              timeDetails,
              incidentLists(),
              `${fallFacility?.label} (${title} - ${shift})`
            )
          }
        />
      ) : null}
    </LayerContent>
  );
};

export default TimeOfIncident;
